(function() {
'use strict'

AppTabs.createTab( {

name: 'maintenance',
icon: 'toolbox',
text: 'Maintenance',
create: function(init) {
	init.setController( new TabControllerVue({
		el: '#vue-maintenance',
		methods : {
			resetData(){
				this.fetchingLogs = false;

				this.have_access_log = false;
				this.access_log_formatted_filesize = 'Fetching access log...';
				this.access_log_link = '';

				this.have_activity_log = false;
				this.activity_log_formatted_filesize = 'Fetching activity log...';
				this.activity_log_link = '';

				this.have_error_log = false;
				this.error_log_formatted_filesize = 'Fetching error log...';
				this.error_log_link = '';

				this.have_activity_error_log = false;
				this.activity_error_log_formatted_filesize = 'Fetching activity error log...';
				this.activity_error_log_link = '';
			},
			onShowTab: function () {
				const _this = this;
				_this.fetchingLogs = true;

				window.ajaxCall({
					data : {
						action: 'get_logs',
					},
					onSuccess : function( response ) {
						_this.have_access_log = response.data.access_log.exists;
						_this.access_log_formatted_filesize = response.data.access_log.formatted_filesize;
						_this.access_log_link = response.data.access_log.link;

						_this.have_activity_log = response.data.activity_log.exists;
						_this.activity_log_formatted_filesize = response.data.activity_log.formatted_filesize;
						_this.activity_log_link = response.data.activity_log.link;

						_this.have_error_log = response.data.error_log.exists;
						_this.error_log_formatted_filesize = response.data.error_log.formatted_filesize;
						_this.error_log_link = response.data.error_log.link;

						_this.have_activity_error_log = response.data.activity_error_log.exists;
						_this.activity_error_log_formatted_filesize = response.data.activity_error_log.formatted_filesize;
						_this.activity_error_log_link = response.data.activity_error_log.link;
					},
					onError : function( response ) {
						alert( 'Could not load logs.' );
					},
					onComplete : function() {
						_this.fetchingLogs = false;
					},
				});
			},
			clearAccessLog : function () {
				const _this = this;
				window.ConfirmationModalManager.show({
					title 		: 'Confirm Clear Access Log',
					message		: 'Are you sure you want to permanently delete the Access Log?',
					buttonText	: 'Clear',
					callback 	: function() {
						window.ajaxCall({
							data : {
								action: 'clear_access_log',
							},
							successMessage: 'Successfully cleared Access Log',
							onSuccess : function( data ) {
								_this.have_access_log = false;
								_this.access_log_formatted_filesize = 'Nothing logged today';
							},
						});
					},
				});
			},
			clearActivityLog : function () {
				const _this = this;
				window.ConfirmationModalManager.show({
					title 		: 'Confirm Clear Activity Log',
					message		: 'Are you sure you want to permanently delete the Activity Log?',
					buttonText	: 'Clear',
					callback 	: function() {
						window.ajaxCall({
							data : {
								action: 'clear_activity_log',
							},
							successMessage: 'Successfully cleared Activity Log',
							onSuccess : function( data ) {
								_this.have_activity_log = false;
								_this.activity_log_formatted_filesize = 'Nothing logged today';
							},
						});
					},
				});
			},
			clearErrorLog : function () {
				const _this = this;
				window.ConfirmationModalManager.show({
					title 		: 'Confirm Clear Error Log',
					message		: 'Are you sure you want to permanently delete the Error Log?',
					buttonText	: 'Clear',
					callback 	: function() {
						window.ajaxCall({
							data : {
								action: 'clear_error_log',
							},
							successMessage: 'Successfully cleared Error Log',
							onSuccess : function( data ) {
								_this.have_error_log = false;
								_this.error_log_formatted_filesize = 'Nothing logged today';
							},
						});
					},
				});
			},
			clearActivityErrorLog : function () {
				const _this = this;
				window.ConfirmationModalManager.show({
					title 		: 'Confirm Clear Activity Error Log',
					message		: 'Are you sure you want to permanently delete the Activity Error Log?',
					buttonText	: 'Clear',
					callback 	: function() {
						window.ajaxCall({
							data : {
								action: 'clear_activity_error_log',
							},
							successMessage: 'Successfully cleared Activity Error Log',
							onSuccess : function( data ) {
								_this.have_activity_error_log = false;
								_this.activity_error_log_formatted_filesize = 'Nothing logged today';
							},
						});
					},
				});
			},
		}
	}) );

}

})

})();
